export default {
  // app.vue
  appvue: {},

  // header.vue
  headervue: {},

  // 列表元数据
  last_meta_data_from_list: null,

  // 用来唤起connect wallet 按钮
  btnaccountvue: {},
};